import React from 'react';

const OrderDetailsModal = ({ order, onClose }) => {
  if (!order) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content order-details-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Order Details</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="detail-section">
            <h3>📋 Order Information</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="label">Order Number:</span>
                <span className="value">{order.orderNumber}</span>
              </div>
              <div className="detail-item">
                <span className="label">Status:</span>
                <span className={`status-badge status-${order.status}`}>{order.status}</span>
              </div>
              <div className="detail-item">
                <span className="label">Created At:</span>
                <span className="value">
                  {new Date(order.createdAt).toLocaleString('en-US', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </span>
              </div>
            </div>
          </div>

          <div className="detail-section">
            <h3>🚗 Car Details</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="label">Company:</span>
                <span className="value">{order.carDetails?.company || 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="label">Model:</span>
                <span className="value">{order.carDetails?.model || 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="label">Year:</span>
                <span className="value">{order.carDetails?.year || 'N/A'}</span>
              </div>
              <div className="detail-item full-width">
                <span className="label">Part Name:</span>
                <span className="value">{order.carDetails?.partName || 'N/A'}</span>
              </div>
              {order.carDetails?.originalQuery && (
                <div className="detail-item full-width">
                  <span className="label">Original Query:</span>
                  <span className="value query-text">{order.carDetails.originalQuery}</span>
                </div>
              )}
            </div>
          </div>

          <div className="detail-section">
            <h3>👤 Customer Information</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="label">Name:</span>
                <span className="value">{order.customerDetails?.name || 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="label">Phone:</span>
                <span className="value">{order.customerDetails?.phone || 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="label">WhatsApp ID:</span>
                <span className="value">{order.customerDetails?.whatsappId || 'N/A'}</span>
              </div>
              {order.deliveryAddress && (
                <div className="detail-item full-width">
                  <span className="label">Delivery Address:</span>
                  <span className="value">{order.deliveryAddress}</span>
                </div>
              )}
            </div>
          </div>

          <div className="detail-section">
            <h3>🏪 Vendor & Payment Details</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="label">Vendor Name:</span>
                <span className="value">{order.vendorDetails?.name || 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="label">Price:</span>
                <span className="value price-value">AED {order.price || '0'}</span>
              </div>
              <div className="detail-item">
                <span className="label">Payment Method:</span>
                <span className="value">{order.paymentMethod || 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="label">Delivery Option:</span>
                <span className="value">
                  {order.deliveryOption === 'delivery' ? '🚚 Home Delivery' : '🏪 Pickup'}
                </span>
              </div>
            </div>
          </div>

          {order.availableQuotes && order.availableQuotes.length > 0 && (
            <div className="detail-section">
              <h3>💰 All Available Quotes ({order.availableQuotes.length})</h3>
              <div className="quotes-list">
                {order.availableQuotes.map((quote, idx) => (
                  <div key={idx} className="quote-card">
                    <div className="quote-vendor">{quote.vendorName}</div>
                    <div className="quote-price">AED {quote.price}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {order.notes && (
            <div className="detail-section">
              <h3>📝 Notes</h3>
              <div className="notes-box">
                {order.notes}
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onClose}>Close</button>
        </div>
      </div>

      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 20px;
          overflow-y: auto;
        }

        .order-details-modal {
          background: white;
          border-radius: 16px;
          width: 100%;
          max-width: 900px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 24px 30px;
          border-bottom: 2px solid #e2e8f0;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 16px 16px 0 0;
        }

        .modal-header h2 {
          margin: 0;
          color: white;
          font-size: 24px;
          font-weight: 700;
        }

        .close-btn {
          background: white;
          border: none;
          font-size: 28px;
          color: #667eea;
          cursor: pointer;
          line-height: 1;
          padding: 0;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s;
        }

        .close-btn:hover {
          background: #f0f0f0;
          transform: rotate(90deg);
        }

        .modal-body {
          padding: 30px;
        }

        .detail-section {
          margin-bottom: 30px;
          padding: 20px;
          background: #f8fafc;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
        }

        .detail-section:last-child {
          margin-bottom: 0;
        }

        .detail-section h3 {
          margin: 0 0 16px 0;
          color: #1e293b;
          font-size: 18px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .detail-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 16px;
        }

        .detail-item {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .detail-item.full-width {
          grid-column: 1 / -1;
        }

        .label {
          font-size: 12px;
          font-weight: 600;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .value {
          font-size: 15px;
          color: #1e293b;
          font-weight: 500;
        }

        .price-value {
          font-size: 18px;
          font-weight: 700;
          color: #059669;
        }

        .query-text {
          font-style: italic;
          color: #475569;
        }

        .status-badge {
          display: inline-block;
          padding: 6px 14px;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 600;
          text-transform: uppercase;
        }

        .status-pending {
          background: #fef3c7;
          color: #d97706;
        }

        .status-confirmed {
          background: #d4f4e2;
          color: #059669;
        }

        .status-completed {
          background: #dbeafe;
          color: #2563eb;
        }

        .status-cancelled {
          background: #fee2e2;
          color: #dc2626;
        }

        .quotes-list {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 12px;
        }

        .quote-card {
          background: white;
          padding: 16px;
          border-radius: 8px;
          border: 2px solid #e2e8f0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all 0.3s;
        }

        .quote-card:hover {
          border-color: #667eea;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
        }

        .quote-vendor {
          font-weight: 600;
          color: #1e293b;
          font-size: 14px;
        }

        .quote-price {
          font-weight: 700;
          color: #059669;
          font-size: 15px;
        }

        .notes-box {
          background: white;
          padding: 16px;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          color: #475569;
          line-height: 1.6;
        }

        .modal-footer {
          padding: 20px 30px;
          border-top: 2px solid #e2e8f0;
          display: flex;
          justify-content: flex-end;
        }

        .btn {
          padding: 12px 24px;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s;
        }

        .btn-primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
        }

        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        }

        @media (max-width: 768px) {
          .order-details-modal {
            max-width: 100%;
            margin: 10px;
          }

          .modal-body {
            padding: 20px;
          }

          .detail-grid {
            grid-template-columns: 1fr;
          }

          .quotes-list {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default OrderDetailsModal;
